import { rcproFormActions } from "../../../../../context/actions/rcproFormActions";
import useStore from "../../../../../context/useStore";

const useFormState = () => {
  const [state, dispatch] = useStore();
  const actions = rcproFormActions(state, dispatch);
  const { rcproForm } = state;
  const { formData, apiData, errors } = rcproForm;
  const { inputsConfig } = state;

  return {
    state,
    dispatch,
    actions,
    rcproForm,
    formData,
    apiData,
    inputsConfig,
    constants: state.constants.items,
    errors,
  };
};

export default useFormState;
